import React from 'react';

import * as S from './LightBulbInfo.styles';

// TODO: use tailwind
export const LightBulbInfo: React.FC = () => {
  return (
    <S.Circle>
      <S.LightBulb />
    </S.Circle>
  );
};
